var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.exercise_goal_number || _vm.recipe_goal_number
    ? _c("div", { attrs: { id: "goal-progress" } }, [
        _vm.showTitle
          ? _c("div", { staticClass: "title" }, [_vm._v("My goals")])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { attrs: { id: "chart-wrapper" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.exercise_goal_number,
                  expression: "exercise_goal_number"
                }
              ],
              attrs: { id: "goal-exercise-chart-wrapper" }
            },
            [
              _c(
                "vue-svg-gauge",
                {
                  class: { complete: _vm.exercise_goal_complete },
                  attrs: {
                    id: "goal-exercise-chart",
                    innerRadius: 80,
                    "start-angle": 0,
                    "end-angle": 360,
                    value: _vm.exercise_percentage,
                    min: 0,
                    max: 1,
                    "separator-step": 0,
                    "scale-interval": 0,
                    baseColor: "#FCFCFC",
                    gaugeColor: "#D1ECE4"
                  }
                },
                [
                  _c("img", {
                    staticClass: "icon",
                    attrs: { src: _vm.exercise_icon, alt: "" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "manual-tally-buttons" }, [
                _vm.showButtons
                  ? _c(
                      "button",
                      {
                        staticClass: "vue-btn",
                        attrs: { disabled: _vm.thinking },
                        on: {
                          click: function($event) {
                            return _vm.update_tally("exercise", true)
                          }
                        }
                      },
                      [_vm._v("-")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButtons
                  ? _c(
                      "button",
                      {
                        staticClass: "vue-btn",
                        attrs: { disabled: _vm.thinking },
                        on: {
                          click: function($event) {
                            return _vm.update_tally("exercise", false)
                          }
                        }
                      },
                      [_vm._v("+")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "completed-text" }, [
                _vm._v(_vm._s(_vm.exercise_text))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.recipe_goal_number,
                  expression: "recipe_goal_number"
                }
              ],
              attrs: { id: "goal-recipe-chart-wrapper" }
            },
            [
              _c(
                "vue-svg-gauge",
                {
                  class: { complete: _vm.recipe_goal_complete },
                  attrs: {
                    id: "goal-recipe-chart",
                    innerRadius: 80,
                    "start-angle": 0,
                    "end-angle": 360,
                    value: _vm.recipe_percentage,
                    min: 0,
                    max: 1,
                    "separator-step": 0,
                    "scale-interval": 0,
                    baseColor: "#FCFCFC",
                    gaugeColor: "#D1ECE4"
                  }
                },
                [
                  _c("img", {
                    staticClass: "icon",
                    attrs: { src: _vm.recipe_icon, alt: "" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "manual-tally-buttons" }, [
                _vm.showButtons
                  ? _c(
                      "button",
                      {
                        staticClass: "vue-btn",
                        attrs: { disabled: _vm.thinking },
                        on: {
                          click: function($event) {
                            return _vm.update_tally("recipe", true)
                          }
                        }
                      },
                      [_vm._v("-")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButtons
                  ? _c(
                      "button",
                      {
                        staticClass: "vue-btn",
                        attrs: { disabled: _vm.thinking },
                        on: {
                          click: function($event) {
                            return _vm.update_tally("recipe", false)
                          }
                        }
                      },
                      [_vm._v("+")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "completed-text" }, [
                _vm._v(_vm._s(_vm.recipe_text))
              ])
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }